import axios from './axios';

export const ImageService = {
  getAll(params = {}) {
    return axios.get('/api/images', { params });
  },
};
